import React, { useState } from 'react'

import CommunityPost from 'shared/components/community/post/CommunityPost'
import CreatePostForm from 'shared/components/community/components/create-post-form/CreatePostForm'
import { LoadingSpinner } from '@elo-kit/components/loading-spinner/LoadingSpinner'
import { POST_STATUSES } from 'constants/communities.constants'
import { withStores } from 'utils/helpers.utils'

const PostWidget = (props) => {
  const { post, communityId, communityPostsStore, isPayerCabinet } = props
  const {
    id,
    title,
    content,
    cover,
    labels,
    createdAt,
    updatedAt,
    member,
    comments,
    likesCount,
    commentsCount,
    liked,
    pinned,
    edited,
    memberId,
    state,
  } = post || {}
  const { original, cropped } = cover?.[0] || {}

  const [editPostMode, setEditPostMode] = useState(false)
  const [showCreateCommentForm, setShowCreateCommentForm] = useState(false)

  const toggleShowCreateCommentForm = () => setShowCreateCommentForm(!showCreateCommentForm)

  const imageLink = cropped || original
  const waitingForReview = state === POST_STATUSES.awaitingReview

  const postWidgetContent = editPostMode ? (
    <CreatePostForm
      {...{
        post,
        setEditPostMode,
      }}
    />
  ) : (
    <CommunityPost waitingForReview={waitingForReview}>
      <CommunityPost.AvatarHeader
        postId={id}
        createdTime={createdAt}
        editedTime={updatedAt}
        waitingForReview={waitingForReview}
        {...{
          member,
          labels,
          pinned,
          setEditPostMode,
          communityId,
          edited,
          isPayerCabinet,
          memberId,
        }}
      />
      <CommunityPost.Content title={title} imageLink={imageLink} description={content} />
      <CommunityPost.LikesAndComments
        postId={id}
        {...{
          likesCount,
          commentsCount,
          liked,
          communityId,
          toggleShowCreateCommentForm,
          showCreateCommentForm,
        }}
      />
      {!waitingForReview && (
        <CommunityPost.Comments
          postId={id}
          {...{
            comments,
            commentsCount,
            communityId,
            isPayerCabinet,
            toggleShowCreateCommentForm,
            showCreateCommentForm,
          }}
        />
      )}
    </CommunityPost>
  )

  return (
    <>
      {communityPostsStore.postsLoadingById[id] ? (
        <LoadingSpinner className='loading-spinner__medium-container' />
      ) : (
        postWidgetContent
      )}
    </>
  )
}

export default withStores(['communityPostsStore'], PostWidget)
